import {decimal} from '../../Function/globalFunction';

export function headers(active_year) {
    const year = active_year;
    let data = [
        {label: 'Staff No.', key: "staffNo"},
        {label: 'Employee', key: "employeeName"},
        {label: 'Position', key: "position"},
        {label: 'Location', key: "location"},
        {label: 'Department', key: "department"},
        {label: 'Join Date', key: "entry_date"},
        {label: 'Status', key: "active_label"},
    ]

    for (let i = 2; i >= 0; i--) {
        data.push(
            {label: year[i] + ' AL Full Year Entitlement', key: 'yearly_entitlement_' + year[i]},
            {label: year[i] + ' AL Entitled', key: 'total_' + year[i]},
            {label: year[i] + ' AL Taken', key: 'taken_' + year[i]},
            {label: year[i] + ' AL Balance', key: 'balance_' + year[i]},
            {label: year[i] + ' SH AL Entitled', key: 'gov_leave_total_' + year[i]},
            {label: year[i] + ' SH AL Balance', key: 'gov_leave_balance_' + year[i]},
        )
    }

    data.push(
        {label: 'SL Entitled', key: 'sick_total'},
        {label: 'SL Taken', key: 'sick_taken'},
        {label: 'SL Balance', key: 'sick_balance'},

        {label: 'Maternity Leave Taken', key: 'maternity_leave_taken'},
        {label: 'Paternity Leave Taken', key: 'paternity_leave_taken'},
        {label: 'Marriage Leave Taken', key: 'marriage_leave_taken'},
        {label: 'Birthday Leave Taken', key: 'birthday_leave_taken'},
        {label: 'Compassionate Leave Taken', key: 'compassionate_leave_taken'},
        {label: 'Examination Leave Taken', key: 'examination_leave_taken'},
        {label: 'Jury Leave Taken', key: 'jury_leave_taken'},
        {label: 'No Pay Leave Taken', key: 'no_pay_leave_taken'},
        {label: 'Compensation Leave Taken', key: 'compensation_leave_taken'},
        {label: 'Other Leave Taken', key: 'other_leave_taken'},
    )

    return data;
}

export function data(csvData) {
    const annualAllowances = csvData.annual_allowances
    const sickAllowances = csvData.sick_allowances
    const allowancesWithoutTotal = csvData.allowances_without_total

    let data = {
        employeeName: `${csvData.employee_name}`,
        staffNo: `${csvData.staff_no}`,
        position: `${csvData.position}`,
        location: `${csvData.location ? csvData.location.name : ''}`,
        department: `${csvData.department ? csvData.department.name : ''}`,
        entry_date: `${csvData.entry_date}`,
        active_label: `${csvData.active_label}`,
    }

    for (let i = 0; i < 3; i++) {
        if (annualAllowances[i]) {
            data['total_' + annualAllowances[i].year] = decimal(annualAllowances[i].total);
            data['taken_' + annualAllowances[i].year] = decimal(annualAllowances[i].taken);
            data['balance_' + annualAllowances[i].year] = decimal(annualAllowances[i].balance);
            data['yearly_entitlement_' + annualAllowances[i].year] = decimal(annualAllowances[i].yearly_entitlement);
            data['gov_leave_total_' + annualAllowances[i].year] = decimal(annualAllowances[i].gov_leave_total);
            data['gov_leave_taken_' + annualAllowances[i].year] = decimal(annualAllowances[i].gov_leave_taken);
            data['gov_leave_balance_' + annualAllowances[i].year] = decimal(annualAllowances[i].gov_leave_balance);
        }
    }

    data['sick_total'] = decimal(sickAllowances.total);
    data['sick_taken'] = decimal(sickAllowances.taken);
    data['sick_balance'] = decimal(sickAllowances.balance);

    for (let i = 0; i < allowancesWithoutTotal.length; i++) {
        data[allowancesWithoutTotal[i].type.name.replace(" ", "_").toLowerCase() + '_taken'] = decimal(allowancesWithoutTotal[i].amount);
    }

    return data;
}
